import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../lib/store'

export default function Header() {
  const { user, logout } = useAuth()
  const nav = useNavigate()
  return (
    <header style={{borderBottom:'1px solid var(--ink)',background:'var(--surface)'}}>
      <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-3">
        <Link to="/" className="text-[1.25rem] font-semibold serif tracking-tight no-underline" style={{color:'var(--ink)'}}>
          高考志愿助手
        </Link>
        <nav className="hidden sm:flex items-center gap-4" style={{fontSize:'var(--fs-body)',fontWeight:500,color:'var(--ink2)'}}>
          <Link to="/schools" className="no-underline hover:text-[var(--ink)]" style={{color:'var(--ink2)',transition:'color 150ms'}}>查院校</Link>
          <Link to="/insights" className="no-underline hover:text-[var(--ink)]" style={{color:'var(--ink2)',transition:'color 150ms'}}>看统计</Link>
          <Link to="/ai-volunteer" className="no-underline hover:text-[var(--ink)]" style={{color:'var(--ink2)',transition:'color 150ms'}}>AI 志愿</Link>
          <Link to="/hot-rankings" className="no-underline hover:text-[var(--ink)]" style={{color:'var(--ink2)',transition:'color 150ms'}}>热度</Link>
          <Link to="/announcements" className="no-underline hover:text-[var(--ink)]" style={{color:'var(--ink2)',transition:'color 150ms'}}>最新公告</Link>
          <Link to="/about" className="no-underline hover:text-[var(--ink)]" style={{color:'var(--ink2)',transition:'color 150ms'}}>关于我们</Link>
          {user?.isAdmin && (
            <Link to="/admin/users" className="no-underline hover:text-[var(--ink)]" style={{color:'var(--ink2)',transition:'color 150ms',fontWeight:600}}>用户管理</Link>
          )}
        </nav>
        <div className="flex items-center gap-3" style={{fontSize:'var(--fs-body)'}}>
          {user ? (
            <>
              <span style={{color:'var(--ink2)'}}>
                <span className="mono" style={{fontWeight:500}}>{user.nickname || user.phone}</span>
                {user.isAdmin && <span className="tag-admin" style={{marginLeft:6,padding:'1px 6px',fontSize:10,fontWeight:600,letterSpacing:'.12em'}}>ADMIN</span>}
              </span>
              <button onClick={()=>{logout();nav('/')}} style={{color:'var(--ink3)',background:'none',border:'none',cursor:'pointer',fontSize:'var(--fs-body)',transition:'color 150ms'}} onMouseOver={e=>{(e.target as HTMLElement).style.color='var(--ink)'}} onMouseOut={e=>{(e.target as HTMLElement).style.color='var(--ink3)'}}>退出</button>
            </>
          ) : (
            <Link to="/login" className="no-underline" style={{color:'var(--ink2)',fontSize:'var(--fs-body)'}}>登录</Link>
          )}
        </div>
      </div>
    </header>
  )
}
